var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#13CFE8",
    d: "M4.9 5.6a2.1 2.1 0 0 0-1.26 3.78l9.52 7.14a1.4 1.4 0 0 0 1.68 0l9.52-7.14A2.101 2.101 0 0 0 23.1 5.6zm-2.1 4.9v9.1c0 1.544 1.256 2.8 2.8 2.8h16.8c1.544 0 2.8-1.256 2.8-2.8v-9.1l-9.52 7.14a2.796 2.796 0 0 1-3.36 0z"
  })));
};
export default SvgEnvelope;